<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolID" style="font-size:smaller;"
					[(ngModel)]="SchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onAddMerit()">Add Merit</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEditMerit()">Edit Merit</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onToggleMerit()">Toggle Merit</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstMerit"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedMerit"
		dataKey="MeritID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--MeritDesc-->
				<th>
					<p-columnFilter type="text" field="MeritDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MeritCD-->
				<th>
					<p-columnFilter type="text" field="MeritCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--IsDemeritDesc-->
				<th>
					<p-columnFilter field="IsDemeritDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsDemeritDesc
								[ngModel]="value"
								[options]="lstIsDemeritDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--MeritValue-->
				<th>
					<p-columnFilter type="text" field="MeritValue" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MeritValueMin-->
				<th>
					<p-columnFilter type="text" field="MeritValueMin" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MeritValueMax-->
				<th>
					<p-columnFilter type="text" field="MeritValueMax" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--QuickMerit-->
				<th>
					<p-columnFilter field="QuickMerit" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterQuickMerit
								[ngModel]="value"
								[options]="lstQuickMerit"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--UsedByDesc-->
				<th>
					<p-columnFilter field="UsedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUsedByDesc
								[ngModel]="value"
								[options]="lstUsedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="MeritDesc">Description<p-sortIcon field="MeritDesc"></p-sortIcon></th>
				<th pSortableColumn="MeritCD">Code<p-sortIcon field="MeritCD"></p-sortIcon></th>
				<th pSortableColumn="IsDemeritDesc">Merit/Demerit<p-sortIcon field="IsDemeritDesc"></p-sortIcon></th>
				<th pSortableColumn="MeritValue">Value<p-sortIcon field="MeritValue"></p-sortIcon></th>
				<th pSortableColumn="MeritValueMin">Minimum Value<p-sortIcon field="MeritValueMin"></p-sortIcon></th>
				<th pSortableColumn="MeritValueMax">Maximum Value<p-sortIcon field="MeritValueMax"></p-sortIcon></th>
				<th pSortableColumn="QuickMeritDesc">Quick Merit<p-sortIcon field="QuickMeritDesc"></p-sortIcon></th>
				<th pSortableColumn="UsedByDesc">Used By<p-sortIcon field="UsedByDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Merit>
			<tr [pSelectableRow]="Merit" (dblclick)="onRowDblClick(Merit)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Merit[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
